// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.index-module__audit-log-title--Bmkvl{text-align:center;margin:20px 0 50px}.index-module__audit-log-modal-container--cIhIX{max-height:80vh;min-height:25vh;padding:0 160px}.index-module__empty-text--dkb1M{display:inline-block;text-align:center;font-size:15px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"audit-log-title": `index-module__audit-log-title--Bmkvl`,
	"auditLogTitle": `index-module__audit-log-title--Bmkvl`,
	"audit-log-modal-container": `index-module__audit-log-modal-container--cIhIX`,
	"auditLogModalContainer": `index-module__audit-log-modal-container--cIhIX`,
	"empty-text": `index-module__empty-text--dkb1M`,
	"emptyText": `index-module__empty-text--dkb1M`
};
export default ___CSS_LOADER_EXPORT___;
